//Imports
import {
  STAFF_PLANNER_LIST_REQUEST,
  STAFF_PLANNER_DATA_REQUEST,
  STAFF_PLANNER_CREATE_REQUEST,
  STAFF_PLANNER_UPDATE_REQUEST,
  STAFF_PLANNER_DELETE_REQUEST,
  STAFF_PLANNER_SEARCH_REQUEST,
  STAFF_PLANNER_COMPLETE_REQUEST,
  STAFF_PLANNER_UNINVOICED_REQUEST,
  STAFF_PLANNER_CONVERT_TO_INVOICE_REQUEST,
  STAFF_PLANNER_GENERATE_RECURRENCE_REQUEST,
  STAFF_PLANNER_STATUS_LIST_REQUEST,
  STAFF_PLANNER_RECENT_ACTIVITY_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_LIST_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_DATA_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_CREATE_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_UPDATE_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_DELETE_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_ASSIGN_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_UNASSIGN_REQUEST,
} from "./actionType";

//actions import
import {
  staffPlannerListSuccess,
  staffPlannerListFail,
  staffPlannerDataSuccess,
  staffPlannerDataFail,
  staffPlannerCreateSuccess,
  staffPlannerCreateFail,
  staffPlannerUpdateSuccess,
  staffPlannerUpdateFail,
  staffPlannerDeleteSuccess,
  staffPlannerDeleteFail,
  staffPlannerSearchSuccess,
  staffPlannerSearchFail,
  staffPlannerCompleteSuccess,
  staffPlannerCompleteFail,
  staffPlannerUninvoicedSuccess,
  staffPlannerUninvoicedFail,
  staffPlannerConvertToInvoiceSuccess,
  staffPlannerConvertToInvoiceFail,
  staffPlannerGenerateRecurrenceSuccess,
  staffPlannerGenerateRecurrenceFail,
  staffPlannerStatusListSuccess,
  staffPlannerStatusListFail,
  staffPlannerRecentActivitySuccess,
  staffPlannerRecentActivityFail,
  staffPlannerAssignmentListSuccess,
  staffPlannerAssignmentListFail,
  staffPlannerAssignmentDataSuccess,
  staffPlannerAssignmentDataFail,
  staffPlannerAssignmentCreateSuccess,
  staffPlannerAssignmentCreateFail,
  staffPlannerAssignmentUpdateSuccess,
  staffPlannerAssignmentUpdateFail,
  staffPlannerAssignmentDeleteSuccess,
  staffPlannerAssignmentDeleteFail,
  staffPlannerAssignmentAssignSuccess,
  staffPlannerAssignmentAssignFail,
  staffPlannerAssignmentUnassignSuccess,
  staffPlannerAssignmentUnassignFail,
} from "./action";

//Imports saga
import { takeEvery, put, call, all, fork } from "redux-saga/effects";

//API URLs
import {
  fetchStaffPlannerList,
  fetchStaffPlannerData,
  createStaffPlanner,
  updateStaffPlanner,
  deleteStaffPlanner,
  searchStaffPlanner,
  completeStaffPlanner,
  uninvoicedStaffPlanner,
  convertToInvoiceStaffPlanner,
  generateRecurrenceStaffPlanner,
  fetchStaffPlannerStatusList,
  fetchStaffPlannerRecentActivity,
  fetchStaffPlannerAssignmentList,
  fetchStaffPlannerAssignmentData,
  createStaffPlannerAssignment,
  updateStaffPlannerAssignment,
  deleteStaffPlannerAssignment,
  assignStaffPlannerAssignment,
  unassignStaffPlannerAssignment,
} from "../../helpers/fakebackend_helper";

//STAFF_PLANNER_LIST Saga
function* staffPlannerListSaga() {
  try {
    const response = yield call(fetchStaffPlannerList);
    yield put(staffPlannerListSuccess(response));
  } catch (error) {
    yield put(staffPlannerListFail(error.message));
  }
}

//STAFF_PLANNER_LIST watcher
function* watchStaffPlannerList() {
  yield takeEvery(STAFF_PLANNER_LIST_REQUEST, staffPlannerListSaga);
}

//STAFF_PLANNER_DATA Saga
function* staffPlannerDataSaga(action) {
  try {
    const response = yield call(fetchStaffPlannerData, action.payload);
    yield put(staffPlannerDataSuccess(response));
  } catch (error) {
    yield put(staffPlannerDataFail(error.message));
  }
}

//STAFF_PLANNER_DATA watcher
function* watchStaffPlannerData() {
  yield takeEvery(STAFF_PLANNER_DATA_REQUEST, staffPlannerDataSaga);
}

//STAFF_PLANNER_CREATE Saga
function* staffPlannerCreateSaga(action) {
  try {
    const response = yield call(createStaffPlanner, action.payload);
    yield put(staffPlannerCreateSuccess(response));
  } catch (error) {
    yield put(staffPlannerCreateFail(error.message));
  }
}

//STAFF_PLANNER_CREATE watcher
function* watchStaffPlannerCreate() {
  yield takeEvery(STAFF_PLANNER_CREATE_REQUEST, staffPlannerCreateSaga);
}

//STAFF_PLANNER_UPDATE Saga
function* staffPlannerUpdateSaga(action) {
  try {
    const response = yield call(updateStaffPlanner, action.payload);
    yield put(staffPlannerUpdateSuccess(response));
  } catch (error) {
    yield put(staffPlannerUpdateFail(error.message));
  }
}

//STAFF_PLANNER_UPDATE watcher
function* watchStaffPlannerUpdate() {
  yield takeEvery(STAFF_PLANNER_UPDATE_REQUEST, staffPlannerUpdateSaga);
}

//STAFF_PLANNER_DELETE Saga
function* staffPlannerDeleteSaga(action) {
  try {
    const response = yield call(deleteStaffPlanner, action.payload);
    yield put(staffPlannerDeleteSuccess(response));
  } catch (error) {
    yield put(staffPlannerDeleteFail(error.message));
  }
}

//STAFF_PLANNER_DELETE watcher
function* watchStaffPlannerDelete() {
  yield takeEvery(STAFF_PLANNER_DELETE_REQUEST, staffPlannerDeleteSaga);
}

//STAFF_PLANNER_SEARCH Saga
function* staffPlannerSearchSaga(action) {
  try {
    const response = yield call(searchStaffPlanner, action.payload);
    yield put(staffPlannerSearchSuccess(response));
  } catch (error) {
    yield put(staffPlannerSearchFail(error.message));
  }
}

//STAFF_PLANNER_SEARCH watcher
function* watchStaffPlannerSearch() {
  yield takeEvery(STAFF_PLANNER_SEARCH_REQUEST, staffPlannerSearchSaga);
}

//STAFF_PLANNER_COMPLETE Saga
function* staffPlannerCompleteSaga(action) {
  try {
    const response = yield call(completeStaffPlanner, action.payload);
    yield put(staffPlannerCompleteSuccess(response));
  } catch (error) {
    yield put(staffPlannerCompleteFail(error.message));
  }
}

//STAFF_PLANNER_COMPLETE watcher
function* watchStaffPlannerComplete() {
  yield takeEvery(STAFF_PLANNER_COMPLETE_REQUEST, staffPlannerCompleteSaga);
}

//STAFF_PLANNER_UNINVOICED Saga
function* staffPlannerUninvoicedSaga(action) {
  try {
    const response = yield call(uninvoicedStaffPlanner, action.payload);
    yield put(staffPlannerUninvoicedSuccess(response));
  } catch (error) {
    yield put(staffPlannerUninvoicedFail(error.message));
  }
}

//STAFF_PLANNER_UNINVOICED watcher
function* watchStaffPlannerUninvoiced() {
  yield takeEvery(STAFF_PLANNER_UNINVOICED_REQUEST, staffPlannerUninvoicedSaga);
}

//STAFF_PLANNER_CONVERT_TO_INVOICE Saga
function* staffPlannerConvertToInvoiceSaga(action) {
  try {
    const response = yield call(convertToInvoiceStaffPlanner, action.payload);
    yield put(staffPlannerConvertToInvoiceSuccess(response));
  } catch (error) {
    yield put(staffPlannerConvertToInvoiceFail(error.message));
  }
}

//STAFF_PLANNER_CONVERT_TO_INVOICE watcher
function* watchStaffPlannerConvertToInvoice() {
  yield takeEvery(
    STAFF_PLANNER_CONVERT_TO_INVOICE_REQUEST,
    staffPlannerConvertToInvoiceSaga
  );
}

//STAFF_PLANNER_GENERATE_RECURRENCE Saga
function* staffPlannerGenerateRecurrenceSaga(action) {
  try {
    const response = yield call(
      generateRecurrenceStaffPlanner,
      action.payload
    );
    yield put(staffPlannerGenerateRecurrenceSuccess(response));
  } catch (error) {
    yield put(staffPlannerGenerateRecurrenceFail(error.message));
  }
}

//STAFF_PLANNER_GENERATE_RECURRENCE watcher
function* watchStaffPlannerGenerateRecurrence() {
  yield takeEvery(
    STAFF_PLANNER_GENERATE_RECURRENCE_REQUEST,
    staffPlannerGenerateRecurrenceSaga
  );
}

//STAFF_PLANNER_STATUS_LIST Saga
function* staffPlannerStatusListSaga() {
  try {
    const response = yield call(fetchStaffPlannerStatusList);
    yield put(staffPlannerStatusListSuccess(response));
  } catch (error) {
    yield put(staffPlannerStatusListFail(error.message));
  }
}

//STAFF_PLANNER_STATUS_LIST watcher
function* watchStaffPlannerStatusList() {
  yield takeEvery(STAFF_PLANNER_STATUS_LIST_REQUEST, staffPlannerStatusListSaga);
}

//STAFF_PLANNER_RECENT_ACTIVITY Saga
function* staffPlannerRecentActivitySaga(action) {
  try {
    const response = yield call(
      fetchStaffPlannerRecentActivity,
      action.payload
    );
    yield put(staffPlannerRecentActivitySuccess(response));
  } catch (error) {
    yield put(staffPlannerRecentActivityFail(error.message));
  }
}

//STAFF_PLANNER_RECENT_ACTIVITY watcher
function* watchStaffPlannerRecentActivity() {
  yield takeEvery(
    STAFF_PLANNER_RECENT_ACTIVITY_REQUEST,
    staffPlannerRecentActivitySaga
  );
}

//STAFF_PLANNER_ASSIGNMENT_LIST Saga
function* staffPlannerAssignmentListSaga() {
  try {
    const response = yield call(fetchStaffPlannerAssignmentList);
    yield put(staffPlannerAssignmentListSuccess(response));
  } catch (error) {
    yield put(staffPlannerAssignmentListFail(error.message));
  }
}

//STAFF_PLANNER_ASSIGNMENT_LIST watcher
function* watchStaffPlannerAssignmentList() {
  yield takeEvery(
    STAFF_PLANNER_ASSIGNMENT_LIST_REQUEST,
    staffPlannerAssignmentListSaga
  );
}

//STAFF_PLANNER_ASSIGNMENT_DATA Saga
function* staffPlannerAssignmentDataSaga(action) {
  try {
    const response = yield call(
      fetchStaffPlannerAssignmentData,
      action.payload
    );
    yield put(staffPlannerAssignmentDataSuccess(response));
  } catch (error) {
    yield put(staffPlannerAssignmentDataFail(error.message));
  }
}

//STAFF_PLANNER_ASSIGNMENT_DATA watcher
function* watchStaffPlannerAssignmentData() {
  yield takeEvery(
    STAFF_PLANNER_ASSIGNMENT_DATA_REQUEST,
    staffPlannerAssignmentDataSaga
  );
}

//STAFF_PLANNER_ASSIGNMENT_CREATE Saga
function* staffPlannerAssignmentCreateSaga(action) {
  try {
    const response = yield call(createStaffPlannerAssignment, action.payload);
    yield put(staffPlannerAssignmentCreateSuccess(response));
  } catch (error) {
    yield put(staffPlannerAssignmentCreateFail(error.message));
  }
}

//STAFF_PLANNER_ASSIGNMENT_CREATE watcher
function* watchStaffPlannerAssignmentCreate() {
  yield takeEvery(
    STAFF_PLANNER_ASSIGNMENT_CREATE_REQUEST,
    staffPlannerAssignmentCreateSaga
  );
}

//STAFF_PLANNER_ASSIGNMENT_UPDATE Saga
function* staffPlannerAssignmentUpdateSaga(action) {
  try {
    const response = yield call(updateStaffPlannerAssignment, action.payload);
    yield put(staffPlannerAssignmentUpdateSuccess(response));
  } catch (error) {
    yield put(staffPlannerAssignmentUpdateFail(error.message));
  }
}

//STAFF_PLANNER_ASSIGNMENT_UPDATE watcher
function* watchStaffPlannerAssignmentUpdate() {
  yield takeEvery(
    STAFF_PLANNER_ASSIGNMENT_UPDATE_REQUEST,
    staffPlannerAssignmentUpdateSaga
  );
}

//STAFF_PLANNER_ASSIGNMENT_DELETE Saga
function* staffPlannerAssignmentDeleteSaga(action) {
  try {
    const response = yield call(deleteStaffPlannerAssignment, action.payload);
    yield put(staffPlannerAssignmentDeleteSuccess(response));
  } catch (error) {
    yield put(staffPlannerAssignmentDeleteFail(error.message));
  }
}

//STAFF_PLANNER_ASSIGNMENT_DELETE watcher
function* watchStaffPlannerAssignmentDelete() {
  yield takeEvery(
    STAFF_PLANNER_ASSIGNMENT_DELETE_REQUEST,
    staffPlannerAssignmentDeleteSaga
  );
}

//STAFF_PLANNER_ASSIGNMENT_ASSIGN Saga
function* staffPlannerAssignmentAssignSaga(action) {
  try {
    const response = yield call(assignStaffPlannerAssignment, action.payload);
    yield put(staffPlannerAssignmentAssignSuccess(response));
  } catch (error) {
    yield put(staffPlannerAssignmentAssignFail(error.message));
  }
}

//STAFF_PLANNER_ASSIGNMENT_ASSIGN watcher
function* watchStaffPlannerAssignmentAssign() {
  yield takeEvery(
    STAFF_PLANNER_ASSIGNMENT_ASSIGN_REQUEST,
    staffPlannerAssignmentAssignSaga
  );
}

//STAFF_PLANNER_ASSIGNMENT_UNASSIGN Saga
function* staffPlannerAssignmentUnassignSaga(action) {
  try {
    const response = yield call(unassignStaffPlannerAssignment, action.payload);
    yield put(staffPlannerAssignmentUnassignSuccess(response));
  } catch (error) {
    yield put(staffPlannerAssignmentUnassignFail(error.message));
  }
}

//STAFF_PLANNER_ASSIGNMENT_UNASSIGN watcher
function* watchStaffPlannerAssignmentUnassign() {
  yield takeEvery(
    STAFF_PLANNER_ASSIGNMENT_UNASSIGN_REQUEST,
    staffPlannerAssignmentUnassignSaga
  );
}

//Root saga
export default function* staffPlanner() {
  yield all([
    fork(watchStaffPlannerList),
    fork(watchStaffPlannerData),
    fork(watchStaffPlannerCreate),
    fork(watchStaffPlannerUpdate),
    fork(watchStaffPlannerDelete),
    fork(watchStaffPlannerSearch),
    fork(watchStaffPlannerComplete),
    fork(watchStaffPlannerGenerateRecurrence),
    fork(watchStaffPlannerUninvoiced),
    fork(watchStaffPlannerConvertToInvoice),
    fork(watchStaffPlannerStatusList),
    fork(watchStaffPlannerRecentActivity),
    fork(watchStaffPlannerAssignmentList),
    fork(watchStaffPlannerAssignmentData),
    fork(watchStaffPlannerAssignmentCreate),
    fork(watchStaffPlannerAssignmentUpdate),
    fork(watchStaffPlannerAssignmentDelete),
    fork(watchStaffPlannerAssignmentAssign),
    fork(watchStaffPlannerAssignmentUnassign),
  ]);
}
